import React, {Component} from 'react';
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";
import '../static/assets/sass/main.scss';
import {
    home,
    program,
    contact,
    subscription, 
    about, 
    signup,
} from "../route";
import Home from "./home/Home";
import Program from "./program/Program";
import Contact from "./contact/Contact"
import Subscription from "./subscription/Subscription"
import Footer from "./common/footer/footer";
import About from "./about/about";
import Header from "./common/header/header";
import Signup from './subscription/Signup'



class App extends Component {
    constructor(props) {
        super(props);
    }

    

    render() {
        return (
            <main className="main-body">
                <Header/>
                <Switch>
                    <Route path={home} component={Home} exact/>
                    <Route path={program} component={Program} exact/>
                    <Route path={about} component={About} exact/>
                    <Route path={contact} component={Contact} exact/>
                    <Route path={subscription} component={Subscription} exact/>
                    <Route path={signup} component={Signup} exact/>
                </Switch>
                <Footer />
            </main>
        );
    }
}

 

export default  App;